// client/components/forms/shared/ModuleToggle.jsx
// Toggle-Leiste für Zusatz-Module (Verwaltung, Kontakt vor Ort, etc.)
import React from "react";
import { useTheme } from "../../../context/ThemeContext.jsx";
import { MODULE_REGISTRY } from "../../../../shared/config/formModules.js";
import { Building2, MapPin, UserRound, Receipt, Hash, Info } from "lucide-react";
import AppButton from "../../ui/AppButton.jsx";
const ICON_MAP = {
  Building2,
  MapPin,
  UserRound,
  Receipt,
  Hash,
  Info
};
export default function ModuleToggle({
  availableModules = [],
  enabledModules = [],
  onChange,
  disabled = false
}) {
    const toggle = moduleId => {
    if (disabled) return;
    const isEnabled = enabledModules.includes(moduleId);
    const next = isEnabled ? enabledModules.filter(m => m !== moduleId) : [...enabledModules, moduleId];
    onChange?.(next);
  };
  if (!availableModules.length) return null;
  return <div className="md:col-span-2">
      <div className={`text-xs font-semibold uppercase tracking-wide mb-2 ${"text-blue-300/70"}`}>
        Zusatzbereiche
      </div>
      <div className="flex flex-wrap gap-2">
        {availableModules.map(moduleId => {
        const mod = MODULE_REGISTRY[moduleId];
        if (!mod) return null;
        const isActive = enabledModules.includes(moduleId);
        const IconComp = ICON_MAP[mod.icon];
        return <AppButton key={moduleId} type="button" variant="ghost" size="sm" onClick={() => toggle(moduleId)} disabled={disabled} className={`inline-flex items-center gap-1.5 !px-3 !py-1.5 rounded-lg text-sm transition-all ${isActive ? "seg-btn-active-primary font-semibold" : "seg-btn-idle"} ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`} title={isActive ? `${mod.label} deaktivieren` : `${mod.label} aktivieren`}>
              {IconComp && <IconComp className="w-3.5 h-3.5" />}
              <span>{mod.label}</span>
            </AppButton>;
      })}
      </div>
    </div>;
}